import type { Epic } from '../../../index.js'
import { orderSlice } from '../../../Slice/Order/OrderSlice.js'
import { filter, mergeMap, of } from 'rxjs'
import { catchError, retryWhen } from 'rxjs/operators'
import { serverIsNotAvailable } from '../../../../Framework/Epic/ServerNotAvailable.js'
import { authenticationExpiredOr } from '../../../../Framework/Epic/AuthenticationExpired.js'

export const UnlinkMetadataEpic: Epic = (action$, state$, { [orderSlice.name]: order, OrderRepository }) =>
  action$.pipe(
    filter(order.unlinkMetadatasRequest.match),
    mergeMap((action) =>
      OrderRepository.updateSampleMetaDatas(
        action.payload.orderId,
        action.payload.metadatas.map((x) => ({ ...x, sampleId: undefined }))
      ).pipe(
        mergeMap((response) =>
          of(
            order.unlinkMetadatasSuccess({
              orderId: action.payload.orderId,
              unlinkedMetadatas: response
            })
          )
        ),
        retryWhen(serverIsNotAvailable()),
        catchError((error) =>
          authenticationExpiredOr({
            error,
            failedRequest: action.type,
            failureAction: of(order.unlinkMetadatasFailure({ error }))
          })
        ),
        catchError((error: Error) => {
          console.error('Error unlinking metadata', error)
          return of(order.unlinkMetadatasFailure({ error }))
        })
      )
    )
  )
